import { WIZARD_ACTIVE_HTML_ATTRIBUTE } from '../wizard/constants';

export default function shouldDismissOnOutsideClick(
  event: MouseEvent | TouchEvent,
): boolean {
  const target = event.target;

  if (!(target instanceof Element)) {
    return true;
  }

  if (
    typeof document !== 'undefined' &&
    document.documentElement.hasAttribute(WIZARD_ACTIVE_HTML_ATTRIBUTE)
  ) {
    return false;
  }

  return !target.closest('[data-state]');
}
